/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CancelSubscriptionDto,
    CancelSubscriptionDtoFromJSON,
    CancelSubscriptionDtoToJSON,
    CheckoutStatusDto,
    CheckoutStatusDtoFromJSON,
    CheckoutStatusDtoToJSON,
    CreateCheckoutSessionDto,
    CreateCheckoutSessionDtoFromJSON,
    CreateCheckoutSessionDtoToJSON,
    ProrationAmountDto,
    ProrationAmountDtoFromJSON,
    ProrationAmountDtoToJSON,
    RedirectUrlDto,
    RedirectUrlDtoFromJSON,
    RedirectUrlDtoToJSON,
    SubscriptionPriceLookupKeyDto,
    SubscriptionPriceLookupKeyDtoFromJSON,
    SubscriptionPriceLookupKeyDtoToJSON,
    SwitchSubscriptionPriceResponseDto,
    SwitchSubscriptionPriceResponseDtoFromJSON,
    SwitchSubscriptionPriceResponseDtoToJSON,
    SwitchSubscriptionRequestDto,
    SwitchSubscriptionRequestDtoFromJSON,
    SwitchSubscriptionRequestDtoToJSON,
} from '../models';

export interface StripeControllerCreateCheckoutSessionRequest {
    createCheckoutSessionDto: CreateCheckoutSessionDto;
    userAgent?: string;
}

export interface StripeControllerGetCheckoutStatusRequest {
    sessionId: string;
}

export interface StripeControllerGetProrationAmountRequest {
    lookupKey: string;
}

export interface StripeControllerSwitchSubscriptionPriceRequest {
    switchSubscriptionRequestDto: SwitchSubscriptionRequestDto;
}

export interface StripeControllerWebhookRequest {
    stripeSignature: string;
}

/**
 * 
 */
export class StripeApi extends runtime.BaseAPI {

    /**
     * Cancel subscription
     */
    async stripeControllerCancelSubscriptionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<CancelSubscriptionDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/cancel-subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelSubscriptionDtoFromJSON(jsonValue));
    }

    /**
     * Cancel subscription
     */
    async stripeControllerCancelSubscription(initOverrides?: RequestInit): Promise<CancelSubscriptionDto> {
        const response = await this.stripeControllerCancelSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create checkout session
     */
    async stripeControllerCreateCheckoutSessionRaw(requestParameters: StripeControllerCreateCheckoutSessionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RedirectUrlDto>> {
        if (requestParameters.createCheckoutSessionDto === null || requestParameters.createCheckoutSessionDto === undefined) {
            throw new runtime.RequiredError('createCheckoutSessionDto','Required parameter requestParameters.createCheckoutSessionDto was null or undefined when calling stripeControllerCreateCheckoutSession.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.userAgent !== undefined && requestParameters.userAgent !== null) {
            headerParameters['user-agent'] = String(requestParameters.userAgent);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/create-checkout-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCheckoutSessionDtoToJSON(requestParameters.createCheckoutSessionDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedirectUrlDtoFromJSON(jsonValue));
    }

    /**
     * Create checkout session
     */
    async stripeControllerCreateCheckoutSession(requestParameters: StripeControllerCreateCheckoutSessionRequest, initOverrides?: RequestInit): Promise<RedirectUrlDto> {
        const response = await this.stripeControllerCreateCheckoutSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create portal session
     */
    async stripeControllerCreatePortalSessionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<RedirectUrlDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/create-portal-session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedirectUrlDtoFromJSON(jsonValue));
    }

    /**
     * Create portal session
     */
    async stripeControllerCreatePortalSession(initOverrides?: RequestInit): Promise<RedirectUrlDto> {
        const response = await this.stripeControllerCreatePortalSessionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Verify the current user checkout session
     */
    async stripeControllerGetCheckoutStatusRaw(requestParameters: StripeControllerGetCheckoutStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CheckoutStatusDto>> {
        if (requestParameters.sessionId === null || requestParameters.sessionId === undefined) {
            throw new runtime.RequiredError('sessionId','Required parameter requestParameters.sessionId was null or undefined when calling stripeControllerGetCheckoutStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/checkout-sessions/{sessionId}/status`.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters.sessionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckoutStatusDtoFromJSON(jsonValue));
    }

    /**
     * Verify the current user checkout session
     */
    async stripeControllerGetCheckoutStatus(requestParameters: StripeControllerGetCheckoutStatusRequest, initOverrides?: RequestInit): Promise<CheckoutStatusDto> {
        const response = await this.stripeControllerGetCheckoutStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changed subscription price
     */
    async stripeControllerGetProrationAmountRaw(requestParameters: StripeControllerGetProrationAmountRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ProrationAmountDto>> {
        if (requestParameters.lookupKey === null || requestParameters.lookupKey === undefined) {
            throw new runtime.RequiredError('lookupKey','Required parameter requestParameters.lookupKey was null or undefined when calling stripeControllerGetProrationAmount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/proration-amount/{lookupKey}`.replace(`{${"lookupKey"}}`, encodeURIComponent(String(requestParameters.lookupKey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProrationAmountDtoFromJSON(jsonValue));
    }

    /**
     * Changed subscription price
     */
    async stripeControllerGetProrationAmount(requestParameters: StripeControllerGetProrationAmountRequest, initOverrides?: RequestInit): Promise<ProrationAmountDto> {
        const response = await this.stripeControllerGetProrationAmountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get subscriptin price
     */
    async stripeControllerGetSubscriptionPriceRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SubscriptionPriceLookupKeyDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/subscription-price`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPriceLookupKeyDtoFromJSON(jsonValue));
    }

    /**
     * Get subscriptin price
     */
    async stripeControllerGetSubscriptionPrice(initOverrides?: RequestInit): Promise<SubscriptionPriceLookupKeyDto> {
        const response = await this.stripeControllerGetSubscriptionPriceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Reactivate subscription
     */
    async stripeControllerReactivateSubscriptionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/reactivate-subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Reactivate subscription
     */
    async stripeControllerReactivateSubscription(initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.stripeControllerReactivateSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * Changed subscription price
     */
    async stripeControllerSwitchSubscriptionPriceRaw(requestParameters: StripeControllerSwitchSubscriptionPriceRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SwitchSubscriptionPriceResponseDto>> {
        if (requestParameters.switchSubscriptionRequestDto === null || requestParameters.switchSubscriptionRequestDto === undefined) {
            throw new runtime.RequiredError('switchSubscriptionRequestDto','Required parameter requestParameters.switchSubscriptionRequestDto was null or undefined when calling stripeControllerSwitchSubscriptionPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/stripe/switch-subscription-price`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SwitchSubscriptionRequestDtoToJSON(requestParameters.switchSubscriptionRequestDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SwitchSubscriptionPriceResponseDtoFromJSON(jsonValue));
    }

    /**
     * Changed subscription price
     */
    async stripeControllerSwitchSubscriptionPrice(requestParameters: StripeControllerSwitchSubscriptionPriceRequest, initOverrides?: RequestInit): Promise<SwitchSubscriptionPriceResponseDto> {
        const response = await this.stripeControllerSwitchSubscriptionPriceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Webhook
     */
    async stripeControllerWebhookRaw(requestParameters: StripeControllerWebhookRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.stripeSignature === null || requestParameters.stripeSignature === undefined) {
            throw new runtime.RequiredError('stripeSignature','Required parameter requestParameters.stripeSignature was null or undefined when calling stripeControllerWebhook.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.stripeSignature !== undefined && requestParameters.stripeSignature !== null) {
            headerParameters['stripe-signature'] = String(requestParameters.stripeSignature);
        }

        const response = await this.request({
            path: `/api/stripe/webhook`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Webhook
     */
    async stripeControllerWebhook(requestParameters: StripeControllerWebhookRequest, initOverrides?: RequestInit): Promise<boolean> {
        const response = await this.stripeControllerWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
